export const SeriesOption = [
  {
    value: 'series-a',
    label: 'A'
  },
  {
    value: 'series-b',
    label: 'B'
  },
  {
    value: 'series-c',
    label: 'C'
  },
  {
    value: 'series-d',
    label: 'D'
  },
  {
    value: 'series-e',
    label: 'E'
  },
  {
    value: 'series-f',
    label: 'F'
  },
  {
    value: 'series-IPO',
    label: 'IPO'
  }
]
